export enum EntityStoreKey {
  emailProviders = 'emailProviders',
  sharedEmailProviders = 'sharedEmailProviders',
  mailboxSharedEmailProviders = 'mailboxSharedEmailProviders',
}
export enum EmailProvidersErrors {
  onPremise = 'potential_on_premise',
}
